import { useMatch } from '@tanstack/react-router';

export function useIsPublicApplyRoute() {
  return (
    useMatch({
      from: '/participants/_public/projects/$projectId/public-apply',
      shouldThrow: false,
    }) != null
  );
}
